import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { mapSlides } from '../data/content';
export function MapCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const slide = mapSlides[index];
  const go = (step: number) => {
    setDirection(step);
    setIndex(current => (current + step + mapSlides.length) % mapSlides.length);
  };
  return <div className="rounded-2xl border border-night-line bg-night-panel p-4 lg:p-5" role="group" aria-roledescription="carrusel" aria-label="Ejemplos de mapas mentales" data-id="element-170" data-mp="3hylghgxj7xxj">
      <div className="relative overflow-hidden rounded-xl bg-parchment" data-id="element-171" data-mp="38xx1aiwejrj2">
        <div className="aspect-[3/2] w-full" data-id="element-172" data-mp="390009sfj8uzx">
          <AnimatePresence initial={false} mode="wait" data-id="element-173" data-mp="1c4bxnegyyi3v">
            <motion.img key={slide.image} src={slide.image} alt={`Mapa mental del libro de ${slide.book}`} initial={{
            opacity: 0,
            x: direction * 24
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction * -24
          }} transition={{
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full w-full object-contain" data-id="element-174" data-mp="176ag4xz6yqui" />
          </AnimatePresence>
        </div>

        <button type="button" onClick={() => go(-1)} aria-label="Mapa anterior" className="absolute left-3 top-1/2 -translate-y-1/2 rounded-full bg-night/85 p-2 text-parchment transition-colors duration-150 ease-out hover:bg-night focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft" data-id="element-175" data-mp="2b6aj8n01pg3x">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-176" data-mp="2u17a6x1zl0tv" />
        </button>
        <button type="button" onClick={() => go(1)} aria-label="Mapa siguiente" className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full bg-night/85 p-2 text-parchment transition-colors duration-150 ease-out hover:bg-night focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft" data-id="element-177" data-mp="3hrbc8zzj0sir">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-178" data-mp="3mfuammfsq3lc" />
        </button>
      </div>

      <div className="mt-4 flex items-center justify-between gap-4" data-id="element-179" data-mp="3hhstw85uegd1">
        <div aria-live="polite" data-id="element-180" data-mp="3dgz4tbgnyvik">
          <p className="font-display text-lg font-semibold text-parchment" data-id="element-181" data-mp="3dia7t92abz8m">{slide.book}</p>
          <p className="font-sans text-sm text-parchment/55" data-id="element-182" data-mp="38p8tb25zq1pk">{slide.block}</p>
        </div>

        <div className="flex items-center gap-2" data-id="element-183" data-mp="33rpcpvltlcug">
          {mapSlides.map((item, slideIndex) => <button key={item.book} type="button" onClick={() => {
          setDirection(slideIndex > index ? 1 : -1);
          setIndex(slideIndex);
        }} aria-label={`Ver el mapa de ${item.book}`} aria-current={slideIndex === index} className={`h-2 rounded-full transition-[width,background-color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft ${slideIndex === index ? 'w-6 bg-gold-soft' : 'w-2 bg-night-line'}`} data-id="element-184" data-mp="2yt5o1nfudmye" data-mpi={slideIndex} />)}
        </div>
      </div>

      <p className="mt-3 font-sans text-sm text-parchment/50" data-id="element-185" data-mp="lm627rdn7jiu">
        Ejemplos reales: {mapSlides.length} de los 73 mapas que vas a recibir.
      </p>
    </div>;
}